import { keysToCamelCase } from "../utils/case-converter";
import { Company } from "./company.interface"

export class CompanyModel implements Company { 
    id: string;
    legalName: string;
    tradeName: string;
    taxId: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    fiscalAddress: string;
    fiscalCity: string;
    fiscalPostalCode: string;
    commercialAddress: string;
    commercialCity: string;
    commercialPostalCode: string;
    active: boolean = true

    constructor(data?: any) {
        if (data) {
            const camelData = keysToCamelCase(data);
            Object.assign(this, camelData);
        }
    }
    
    static empty(): CompanyModel {
        return new CompanyModel();
    }
};